import React from 'react'
import CardAudioPlayer from 'cwp-components/Multimedia/CardAudioPlayer'
import './index.scss'
import { useNavigate } from 'react-router-dom'
import ShareButton from 'cwp-components/ShareButton'

type Props = {
  episode: any
  className?: string
  avatarClassName?: string
  onClickPlay?: () => void
}

const PodcastsCard = ({ episode, className, onClickPlay }: Props) => {
  const navigate = useNavigate()
  return (
    <div className={`episodesX ${className || ''}`}>
      <div className='card h-full'>
        <div className='author mb-3'>
          <div className='info'>
            <div
              className='avatar'
              style={{
                background: `url(${episode.publisher.avatar}) lightgray 50% / cover no-repeat`,
              }}
            ></div>
            <div>
              <p>{episode.publisher.name}</p>
              <p>Published on {episode.publish_date}</p>
            </div>
          </div>
          <ShareButton data={{ title: episode.title, url: episode.url }} />
        </div>
        <div
          className='cover'
          style={{
            background: `url(${
              episode.icon_image || episode.banner_image
            }) lightgray 50% / cover no-repeat`,
          }}
        ></div>
        <CardAudioPlayer episode={episode} onPlay={onClickPlay} />
        <div className='body my-5'>
          <h3
            onClick={() => navigate(`/podcasts/${episode.slug}`)}
            className='mb-3 cursor-pointer '
          >
            {episode.title}
          </h3>
          <p>{episode.description.substring(0, 200)}</p>
        </div>

        <div className='flex flex-wrap mt-5 gap-5'>
          {episode &&
            episode?.speakers?.map((speaker, idx) => (
              <div className='author mb-3' key={idx}>
                <div className='info'>
                  <div
                    className='avatar'
                    style={{
                      background: `url(${speaker.avatar}) lightgray 50% / cover no-repeat`,
                    }}
                  ></div>
                  <div className='ml-1'>
                    <p className='text-[10px]'>{speaker.name}</p>
                    <p className='text-[8px]'>{speaker.type}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className='flex gap-2'>
          {episode.tags.map((tag, idx) => (
            <div
              key={`episode-tag-${idx}`}
              className='badge bg-[#EBF3FF] text-[12px] font-bold'
            >
              {tag}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PodcastsCard
